module.exports = __webpack_public_path__ + "img/image-map-1-d136b976.png";